import axios from "axios";

export const state = {
  documentEmailPayload: {
    emailAddress: "",
    signatureRequestId: ""
  },
  signatureEmailPayload: {
    email: "",
    signatureRequestId: ""
  },
  signatureRequest: {
    signature_request_id: "",
    is_complete: false,
    is_declined: false,
    files_url: "",
    signatures: [],
    title: ""
  },
  signedDocuments: [],
  signedSearchTerm: "",
  unsignedDocuments: [],
  unsignedSearchTerm: "",
  totalSigned: 0,
  totalUnsigned: 0,
  messageType: "",
  snackbar: false,
  snackbarMessage: ""
};

export const totalCount = (documentType) => {
  return documentType.documents.length < documentType.total_count && documentType.total_count <= 25
    ? documentType.documents.length : documentType.total_count;
};

export const actions = {
  getEsignSignatureRequests: ({ commit, dispatch }, signatureRequestsPayload) => {
    if (signatureRequestsPayload.load_new_facility) {
      commit("setSignedDocuments", { documents: [], total_count: 0 });
      commit("setUnsignedDocuments", { documents: [], total_count: 0 });
    }
    return new Promise((resolve, reject) => {
      axios.create({
        baseURL: process.env.VUE_APP_API_ALT_URL
      }).get(`/esign/signature-requests`, {
        params: signatureRequestsPayload
      })
        .then((resp) => {
          signatureRequestsPayload.query.includes("complete:true")
            ? commit("setSignedDocuments", resp.data)
            : commit("setUnsignedDocuments", resp.data);
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err.response.data.message, { root: true });
          reject(err);
        });
    });
  },
  emailEsignSignatureRequest: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      axios.create({
        baseURL: process.env.VUE_APP_API_ALT_URL
      }).post(`/esign/signature-requests/${payload.signatureRequestId}/email-url`, payload)
        .then((resp) => {
          dispatch("handleSuccess", `Document emailed to ${payload.email}!`);
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err.response.data.message, { root: true });
          reject(err);
        });
    });
  },
  emailCompletedEsignSignatureRequest: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      axios.create({
        baseURL: process.env.VUE_APP_API_ALT_URL
      }).post(`/esign/signature-requests/${payload.signatureRequestId}/email-document`, payload)
        .then((resp) => {
          dispatch("handleSuccess", `Document emailed to ${payload.email}!`);
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err.response.data.message, { root: true });
          reject(err);
        });
    });
  },
  deleteEsignSignatureRequest: ({ dispatch }, signatureRequestId) => {
    return new Promise((resolve, reject) => {
      axios.create({
        baseURL: process.env.VUE_APP_API_ALT_URL
      }).delete(`/esign/signature-requests/${signatureRequestId}`)
        .then((resp) => {
          dispatch("getSignatureRequests");
          dispatch("handleSuccess", `Document successfully deleted!`);
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err.response.data.message, { root: true });
          reject(err);
        });
    });
  },
  downloadEsignSignedDocument: ({ dispatch }, signatureRequestId) => {
    return new Promise((resolve, reject) => {
      axios.create({
        baseURL: process.env.VUE_APP_API_ALT_URL
      }).get(`/esign/signature-requests/${signatureRequestId}/download`, {
        responseType: "blob"
      })
        .then((resp) => {
          const fileUrl = window.URL.createObjectURL(new Blob([resp.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileUrl;
          fileLink.setAttribute("download", "signed-documents.pdf");
          document.body.appendChild(fileLink);
          fileLink.click();
          fileLink.remove();
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", "There was an error with downloading the document", { root: true });
          reject(err);
        });
    });
  },
  clearEsignSearchTerms({ commit }) {
    commit("resetSearchTerms");
  },
  setEsignSearchTerm({ commit }, searchTerm) {
    commit("commitSearchTerm", searchTerm);
  },
  clearEsignSignatureRequests({ commit }) {
    commit("resetDocumentManagerState");
  }
};

export const mutations = {
  commitSearchTerm: (state, payload) => {
    payload.searchType === "signed"
      ? state.signedSearchTerm = payload.searchTerm
      : state.unsignedSearchTerm = payload.searchTerm;
  },
  errorMessage: (state, message) => {
    state.messageType = "error";
    state.snackbar = true;
    state.snackbarMessage = message;
  },
  resetDocumentManagerState: (state) => {
    state.signedDocuments = [];
    state.unsignedDocuments = [];
  },
  resetSearchTerms: (state) => {
    state.signedSearchTerm = "";
    state.unsignedSearchTerm = "";
  },
  setSignedDocuments: (state, signedDocuments) => {
    state.signedDocuments = signedDocuments.documents;
    state.totalSigned = totalCount(signedDocuments);
  },
  setUnsignedDocuments: (state, unsignedDocuments) => {
    state.unsignedDocuments = unsignedDocuments.documents;
    state.totalUnsigned = totalCount(unsignedDocuments);
  },
  successMessage: (state, message) => {
    state.messageType = "success";
    state.snackbar = true;
    state.snackbarMessage = message;
  }
};

export default {
  state,
  actions,
  mutations
};
